import { Appear } from "@/components/appear";
import styled from "@emotion/styled";

export const StyledPageWrapper = styled(Appear)({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

export const StyledContentWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing.sm,
  fontSize: theme.fontSizes.small,
  lineHeight: theme.lineHeights.small,
  alignItems: "flex-start",
  color: theme.colors.grey.x700,
  padding: theme.spacing.md,
  flex: 1,
  overflow: "auto",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  paddingTop: theme.spacing.md,
  paddingLeft: theme.spacing.md,
  paddingRight: `max(calc(100% - 800px), ${theme.spacing.md})`,
  paddingBottom: 0,
}));

export const StyledContentSectionTitleWrapper = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing.smd,
  color: theme.colors.grey.x600,
  fontSize: theme.fontSizes.large,
  fontWeight: theme.fontWeights.semiBold,
  margin: 0,

  "& svg": {
    width: "20px",
    height: "20px",
  },
}));

export const StyledContentList = styled.ul(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing.sm,
  margin: `${theme.spacing.sm} 0 0`,
  paddingLeft: theme.spacing.md,
  fontSize: theme.fontSizes.medium,
  color: theme.colors.grey.x600,
  lineHeight: theme.lineHeights.medium,

  ul: {
    margin: `${theme.spacing.sm} 0 0`,
    paddingLeft: theme.spacing.md,
    lineHeight: theme.lineHeights.medium,
  },
}));

export const StyledContentStatusWrapper = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing.xs,
  fontSize: theme.fontSizes.small,
  fontWeight: theme.fontWeights.medium,
  color: theme.colors.grey.x600,

  "& svg": {
    color: theme.colors.green.x500,
  },
}));

export const StyledHeading = styled.h3(({ theme }) => ({
  fontSize: theme.fontSizes.small,
  fontWeight: theme.fontWeights.semiBold,
  lineHeight: theme.lineHeights.small,
  color: theme.colors.grey.x600,
  margin: 0,
}));

export const StyledExplanation = styled.p(({ theme }) => ({
  fontSize: theme.fontSizes.small,
  color: theme.colors.grey.x600,
  lineHeight: theme.lineHeights.small,
  margin: 0,
  marginBottom: theme.spacing.md,
}));

export const StyledSubTitle = styled.div(({ theme }) => ({
  fontSize: theme.fontSizes.xsmall,
  fontWeight: theme.fontWeights.semiBold,
  lineHeight: theme.lineHeights.xsmall,
  color: theme.colors.grey.x500,
}));

export const StyledSubExplanation = styled.p(({ theme }) => ({
  fontSize: theme.fontSizes.xsmall,
  color: theme.colors.grey.x500,
  lineHeight: theme.lineHeights.xsmall,
  margin: 0,
}));

export const StyledContentListText = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing.sm,

  "& svg": {
    color: theme.colors.green.x500,
  },
}));

export const StyledFormattingContentLeftAddon = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xs};
`;

export const StyledFormattingContentRightAddon = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
`;
